"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledDialogLayout = void 0;
var _DialogLayout = require("./DialogLayout");
// TODO: in v9, move styled() from DialogLayout.jsx to here
var StyledDialogLayout = _DialogLayout.DialogLayout;
exports.StyledDialogLayout = StyledDialogLayout;